import React, { Fragment } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  CardMedia,
  Paper,
  Divider,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns"; // Use date-fns to format the date
import SEO from "../../components/ceo/CEO";

const ProgramDetails = () => {
  const location = useLocation();
  const program = location.state;
  const navigate = useNavigate();

  // Format the date using date-fns
  const formattedDate = format(new Date(program.date), "MMMM d, yyyy");

  return (
    <Fragment>
      <SEO
        title={program.title}
        description={program.description}
        url="https://shallafg.org/programs/details/"
        image={program.image}
      />
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          py: 10,
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={8}>
            {/* Left Side: Large Program Image */}
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image={program.image}
                alt={program.title}
                sx={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
                  transition: "transform 0.4s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              />
            </Grid>

            {/* Right Side: Program Information */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={3}
                sx={{
                  backgroundColor: "#1A2E55",
                  p: 4,
                  borderRadius: "16px",
                  boxShadow: "0 6px 30px rgba(0, 0, 0, 0.5)",
                }}
              >
                {/* Title */}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    mb: 2,
                    color: "#FFFFFF",
                    textShadow: "0 4px 12px rgba(0, 0, 0, 0.6)",
                    fontSize: { xs: "2rem", md: "2.75rem" },
                  }}
                >
                  {program.title}
                </Typography>

                {/* Date and Location */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#A9C9EA",
                    mb: 3,
                    fontSize: "1.1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    {formattedDate} • {program.location}
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#007BFF",
                      borderRadius: "50px",
                      padding: "6px 16px",
                      fontSize: "0.85rem",
                      fontWeight: 600,
                      color: "#FFFFFF",
                    }}
                  >
                    {program.program_type_display}
                  </Box>
                </Typography>

                <Divider sx={{ borderColor: "#A9C9EA", my: 2 }} />

                {/* Description */}
                <Typography
                  variant="body1"
                  sx={{
                    color: "#D1D5DB",
                    lineHeight: 1.8,
                    fontSize: "1.2rem",
                    mb: 4,
                  }}
                >
                  {program.description}
                </Typography>

                {/* Report Section */}
                {program.report && (
                  <Paper
                    sx={{
                      backgroundColor: "#0D3A5E",
                      p: 3,
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                      mb: 4,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: "#A9C9EA", mb: 1 }}
                    >
                      Program Report:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "1rem", color: "#FFFFFF" }}
                    >
                      {program.report}
                    </Typography>
                  </Paper>
                )}

                {/* Back Button */}
                <Button
                  variant="contained"
                  onClick={() => navigate("/programs")}
                  sx={{
                    backgroundColor: "#10a7e0",
                    padding: "12px 32px",
                    fontSize: "1rem",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    borderRadius: "12px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#10a7e0",
                      transform: "translateY(-3px)",
                      boxShadow: "0 8px 20px rgba(0, 86, 179, 0.4)",
                    },
                  }}
                >
                  Back to Programs
                </Button>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
};

export default ProgramDetails;
